import tracker from './Tracker';

/**
 * 注册路由 afterEach，自动采集页面浏览事件
 */
export function setupRouterTrack(router) {
  router.afterEach((to, from) => {
    if (to.path === '/login') {
      return;
    }

    tracker.track({
      event_type: 'page_view',
      event_name: String(to.name || to.path),
      page_path: to.fullPath,
      page_title: String(to.name || document.title || ''),
      from_path: from.fullPath || '',
    });
  });
}
